import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/api"; // Side-effect: patches window.fetch to inject Bearer token
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
